import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ChildSafetyPage = () => {
  return (
    <div className="min-h-screen bg-audioyou-bg">
      <header className="neumorphic-header sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-xl bg-audioyou-accent flex items-center justify-center">
                <span className="text-white text-xl">🎙️</span>
              </div>
              <span className="text-xl font-bold text-gray-800">AudioToo</span>
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8">
        <Link to="/" className="neumorphic-button-small inline-flex items-center gap-2 px-3 py-2 mb-6">
          <ArrowLeft size={16} />
          <span>Volver</span>
        </Link>

        <div className="neumorphic-card p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Estándares de seguridad infantil</h1>
          <p className="text-sm text-gray-500 mb-8">Última actualización: 31 de octubre de 2026</p>

          <div className="prose prose-gray max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Nuestro compromiso</h2>
              <p className="text-gray-600 leading-relaxed">
                AudioToo tiene tolerancia cero con la explotación y el abuso sexual infantil (EASI/CSAE).
                Nos comprometemos a prevenir, detectar y eliminar cualquier contenido que sexualice o
                ponga en peligro a menores, y a colaborar con las autoridades competentes.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Medidas que aplicamos</h2>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li><strong>Audiencia adulta:</strong> AudioToo está dirigida exclusivamente a personas mayores de 18 años. No permitimos el registro de menores.</li>
                <li><strong>Denuncia dentro de la app:</strong> cualquier usuario puede denunciar un audio o contenido inapropiado directamente desde el reproductor, incluyendo la categoría de seguridad infantil.</li>
                <li><strong>Revisión y cuarentena:</strong> el contenido denunciado se revisa y, si acumula varias denuncias, se pone en cuarentena automáticamente hasta su resolución.</li>
                <li><strong>Eliminación inmediata:</strong> cualquier contenido que constituya abuso o explotación sexual infantil se elimina de inmediato y la cuenta responsable se suspende de forma permanente.</li>
                <li><strong>Notificación a las autoridades:</strong> cuando detectamos contenido de abuso sexual infantil, lo denunciamos a las autoridades y organizaciones pertinentes (como el NCMEC y los cuerpos de seguridad competentes), conforme a la legislación aplicable.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Cómo denunciar</h2>
              <p className="text-gray-600 leading-relaxed">
                Si ves contenido que pueda estar relacionado con la seguridad infantil:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2 mt-2">
                <li>Usa el botón de denuncia disponible en cada audio dentro de la aplicación, o</li>
                <li>escríbenos a{' '}
                  <a href="mailto:privacy@audiotoo.com" className="text-audioyou-accent hover:underline">
                    privacy@audiotoo.com
                  </a>{' '}
                  con el enlace al contenido. Atendemos estas denuncias con máxima prioridad.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Contacto</h2>
              <p className="text-gray-600 leading-relaxed">
                Responsable de cumplimiento de seguridad infantil:{' '}
                <a href="mailto:nandezgarcia@gmail.com" className="text-audioyou-accent hover:underline">
                  nandezgarcia@gmail.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ChildSafetyPage;
